import { useEffect, useRef, useState } from 'react';

/**
 * Signed-in nav control: a "Hi, {name}" button that opens a small menu with
 * account actions (currently just Log out). Replaces the standalone Log out
 * pill. Closes on outside click or Escape.
 */
export default function AccountMenu({
  firstName,
  onLogout,
}: {
  firstName: string;
  onLogout: () => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="account-menu" ref={ref}>
      <button
        type="button"
        className="account-menu-trigger"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {firstName ? (
          <span>Hi, <span className="account-menu-name">{firstName}</span></span>
        ) : (
          <span className="account-menu-name">Account</span>
        )}
      </button>
      {open && (
        <div className="account-menu-panel" role="menu">
          <button
            type="button"
            role="menuitem"
            className="account-menu-item"
            onClick={() => {
              setOpen(false);
              onLogout();
            }}
          >
            Log out
          </button>
        </div>
      )}
    </div>
  );
}
